var courseDir;
var scorm;
var scoPath;
var socket;

function s4xdmInit() {
    switch (s4xdmConfig.scormVersion) {
        case "12":
            scorm = scorm12Obj;
            break;
        case "2004":
            scorm = scorm2004Obj;
            break;
    }
    document.body.innerHTML = '<div id="scorm_content_frame_201542433" class="fullscreen"></div>';
    scorm.loadDataFromLMS();
    // Make sure the body has rendered the div that holds the frame.
    setTimeout(function() {
        launchProvider(scorm);
    }, 1);
}
window.onload = s4xdmInit;

function s4xdmUnload() {
    scorm.finish();
}
window.onunload = s4xdmUnload;

function displayProtected() {
    var h = document.getElementById("scorm_content_frame_201542433");
    h.innerHTML = "<h1>Access Denied</h1><p>You do not have access to the course you were attempting to open. Please contact your LMS administrator for more information.";
}

function launchProvider(loaderObj) {
    var n, ret, qArray, w, h, i, parsed, scoUrl, utilsInstance;
    utilsInstance = new Utils();
    qArray = utilsInstance.parseQueryString(document.location.href);
    scoPath = qArray.res_21983[0];
    courseDir = s4xdmConfig.courseDir;
    if (qArray.dir_21983 && qArray.dir_21983.length > 0) {
        courseDir = qArray.dir_21983[0];
    }
    console.log("scopath", scoPath, "coursedir", courseDir);

    if (s4xdmConfig.width) {
        w = s4xdmConfig.width;
    }
    else {
        w = 0;
    }

    if (s4xdmConfig.height) {
        h = s4xdmConfig.height;
    }
    else {
        h = 0;
    }

    var remotePath = s4xdmConfig.providerBaseURL,
        providerURL = remotePath + "/provider.htm",
        localEasyxdmHelper = '../js/easyxdm/name.html',
        remoteEasyxdm = remotePath + '/easyxdm/easyxdm.swf',
        remoteEasyxdmHelper = remotePath + '/easyxdm/name.html';
    if (s4xdmConfig.providerURL) {
        providerURL = s4xdmConfig.providerURL;
    }
    console.log("getSCORMData() parameters for comm socket");
    console.log(">>	provider: " + providerURL);
    console.log(">>	swf: " + remoteEasyxdm);
    console.log(">>	local: " + localEasyxdmHelper);
    console.log(">> remoteHelper: " + remoteEasyxdmHelper);
    console.log(">> onMessage: waiting for data...");
    console.log(">> onReady: waiting for data...");

    var props = {};
    if (w && h) {
        props.style = {
            width: w + "px",
            height: h + "px"
        };
    }
    else {
        props.style = {
            width: "100%",
            height: "100%"
        };
    }

    socket = new easyXDM.Socket({
        local: localEasyxdmHelper,
        swf: remoteEasyxdm,
        container: "scorm_content_frame_201542433",
        swfNoThrottle: true,
        remote: providerURL,
        remoteHelper: remoteEasyxdmHelper,
        props: props,
        onMessage: onMessage,
        onReady: bridgeReady
    });
}

function bridgeReady() {
    console.log("onReady fired. comm socket is ready.");
    console.log("courseDir", courseDir);
    var message = {
        action: "load",
        scormVersion: s4xdmConfig.scormVersion,
        details: s4xdmConfig.providerConfig,
        courseDir: courseDir,
        scoPath: scoPath,
        scoData: scorm.getRuntimeData()
    };
    if (s4xdmConfig.shareCookiesWithProvider) {
        message.cookies = Cookies.get();
    }
    console.log("message", JSON.stringify(message));
    socket.postMessage(JSON.stringify(message));
}

function onMessage(message, origin) {
    console.log("onMessage fired message = ", message);
    var parsed = JSON.parse(message);
    if (parsed.command === "alert") {
        alert(parsed.alert);
    }
    else if (parsed.command === "set") {
        scorm.set(parsed.k, parsed.v);
    }
    else if (parsed.command === "commit") {
        scorm.commit();
    }
    else if (parsed.command === "finish") {
        scorm.finish();
    }
    else if (parsed.command === "setCookie") {
        Cookies.set(parsed.k, parsed.v, parsed.cookieProperties);
    }
    else if (parsed.command === "notAllowed") {
        displayProtected();
    }
    else {
        alert("Unknown command in onMessage", message);
    }
}